import { AxiosResponse } from 'axios';

export const API_ACTION_PATHS = {
  LIST: 'list',
  LOAD: 'load',
  CREATE: 'create',
  DELETE: 'delete',
  SAVE: 'save',
};

export function getApiUrl(basePath: string, subPath: string): string {
  return `${basePath}${subPath}`;
}

export function getApiUrlWithParam(
  basePath: string,
  subPath: string,
  paramName: string,
  paramValue: string | number,
): string {
  return `${basePath}${subPath}?${paramName}=${paramValue.toString()}`;
}

export function getApiUrlWithParamWithoutSubPath(
  basePath: string,
  paramName: string,
  paramValue: string | number,
): string {
  return `${basePath}?${paramName}=${paramValue.toString()}`;
}

export function getApiUrlWithParams(
  basePath: string,
  subPath: string,
  params: Record<string, string | number | string[]>,
): string {
  const queryParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (!!key && !!value) {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(key, v));
      } else {
        queryParams.append(key, value.toString());
      }
    }
  }

  const queryString = queryParams.toString();
  return `${basePath}${subPath}${queryString ? `?${queryString}` : ''}`;
}

export function getListApiUrl(basePath: string): string {
  return `${basePath}${API_ACTION_PATHS.LIST}`;
}

export function getLoadApiUrl(basePath: string): string {
  return `${basePath}${API_ACTION_PATHS.LOAD}`;
}

export function getCreateApiUrl(basePath: string): string {
  return `${basePath}${API_ACTION_PATHS.CREATE}`;
}

export function getSaveApiUrl(basePath: string): string {
  return `${basePath}${API_ACTION_PATHS.SAVE}`;
}

export function getDeleteApiUrl(basePath: string): string {
  return `${basePath}${API_ACTION_PATHS.DELETE}`;
}

export function isErrorStatusTextOk(response: AxiosResponse<any, any>): boolean {
  return response.statusText === 'OK';
}
